// src/components/UpdatesTicker.jsx
import { useEffect, useState } from "react";
import axios from "axios";

const API_URL = "https://bcm-backend-9ca9.onrender.com";

export default function UpdatesTicker() {
  const [updates, setUpdates] = useState([]);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const fetchUpdates = async () => {
      try {
        const res = await axios.get(`${API_URL}/updates`);
        setUpdates(res.data || []);
      } catch (err) {
        console.error("Failed to fetch updates:", err);
        setUpdates([]);
      } finally {
        setIsLoading(false);
      }
    };
    fetchUpdates();
  }, []);

  if (isLoading) {
    return (
      <div className="relative overflow-hidden bg-yellow-50/90 backdrop-blur-sm rounded-lg sm:rounded-full shadow-lg py-2 sm:py-2.5 md:py-3 px-4">
        <div className="flex items-center justify-center">
          <span className="text-xs sm:text-sm text-gray-500 font-medium animate-pulse">
            Loading updates...
          </span>
        </div>
      </div>
    );
  }

  if (!updates.length) return null;

  return (
    <div className="relative overflow-hidden bg-gradient-to-r from-yellow-50 via-yellow-100 to-yellow-50 rounded-lg sm:rounded-full shadow-lg border border-yellow-200/50">
      {/* Label for mobile */}
      <div className="absolute left-3 sm:left-4 top-1/2 -translate-y-1/2 bg-red-600 text-white text-[10px] sm:text-xs font-bold px-2 py-0.5 sm:px-2.5 sm:py-1 rounded-full z-10 hidden xs:block">
        UPDATES
      </div>

      {/* Scrolling content */}
      <div className="py-2 sm:py-2.5 md:py-3 pl-0 xs:pl-20 sm:pl-24 pr-4">
        <div className="flex animate-marquee whitespace-nowrap">
          {updates.map((u, i) => (
            <span
              key={u._id || i}
              className="inline-flex items-center mx-4 sm:mx-6 md:mx-8 lg:mx-10 text-xs sm:text-sm md:text-base text-red-700 font-semibold"
            >
              <span className="mr-2 text-base sm:text-lg">🔔</span>
              <span className="drop-shadow-sm">{u.message}</span>
            </span>
          ))}
          {/* Duplicate for seamless loop */}
          {updates.map((u, i) => (
            <span
              key={`dup-${u._id || i}`}
              className="inline-flex items-center mx-4 sm:mx-6 md:mx-8 lg:mx-10 text-xs sm:text-sm md:text-base text-red-700 font-semibold"
            >
              <span className="mr-2 text-base sm:text-lg">🔔</span>
              <span className="drop-shadow-sm">{u.message}</span>
            </span>
          ))}
        </div>
      </div>

      {/* Gradient fade edges */}
      <div className="absolute left-0 top-0 bottom-0 w-8 sm:w-12 md:w-16 bg-gradient-to-r from-yellow-50 to-transparent pointer-events-none"></div>
      <div className="absolute right-0 top-0 bottom-0 w-8 sm:w-12 md:w-16 bg-gradient-to-l from-yellow-50 to-transparent pointer-events-none"></div>

      {/* Animation styles */}
      <style jsx>{`
        @keyframes marquee {
          0% {
            transform: translateX(0);
          }
          100% {
            transform: translateX(-50%);
          }
        }
        .animate-marquee {
          animation: marquee 30s linear infinite;
        }
        .animate-marquee:hover {
          animation-play-state: paused;
        }
        @media (max-width: 640px) {
          .animate-marquee {
            animation-duration: 25s;
          }
        }
        @media (min-width: 1024px) {
          .animate-marquee {
            animation-duration: 35s;
          }
        }
      `}</style>
    </div>
  );
}